import { render, staticRenderFns } from "./PlanSummaryCard.vue?vue&type=template&id=65093f72"
import script from "./PlanSummaryCard.vue?vue&type=script&lang=js"
export * from "./PlanSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports